const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/sro/eCheckin/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        finalizeTitle: 'Allen Informationen erfolgreich erfasst. Sie können den Check-in nun abschliessen.',
        company: 'Firma',
        keinHausarzt: 'Ich habe keinen Hausarzt / Hausärztin',
        kontakt: 'Kontaktperson / Angehörige',
        keineAngaben: 'Ich möchte keine Angaben zu Angehörigen machen',
        persAngaben: 'Persönliche Angaben',
        dateOfBirth: 'Geburtstag',
        gender: 'Geschlecht',
        zivilstand: 'Zivilstand',
        nationality: 'Nationalität',
        profession: 'Beruf',
        religion: 'Religion',
        ahv: 'AHV-Nr.',
        ahvHelpText: 'Geben Sie Ihre 13-stellige AHV-Nummer in dieses Feld ein.',
        versicherungLabel: 'Ver­sicherung',
        versicherungName: 'Name der Versicherung',
        behandlungsgrund: 'Behandlungs­grund',
        kostenuebernahme: 'Kostenübernahme und Einverständnis',
        datenweitergabeText:
            'Ich bin mit der Direktabrechnung der SRO AG mit meinem Versicherer und der damit verbundenen elektronischen und gesicherten Deckungs- bzw. Online-Abfrage im Versichertenkarten-Center alles Krankenversicherer einverstanden.',
        zustVersicherung: 'Kostenträger',
        versichertenKartenNr: 'Versicherungskarten-Nr.',
        klasse: 'Versicherungsklasse',
        telMobile: 'Telefon Mobile',
        telFestnetz: 'Telefon Festnetz',
        telGeschaeft: 'Telefon Geschäft',
        vip: 'Mitarbeitende/r oder Angehörige/r eines Mitarbeitenden der SRO AG?',
        vipInfo: 'Arbeiten Sie in der SRO AG oder sind Sie Angehörige/r eines Mitarbeitenden? Dann können Sie sich als VIP (very important Person) aufnehmen lassen.',
        vipMoreInfo: 'Weitere Informationen:',
        vipFlyerLink: 'Merkblatt VIP Status',
        religionOther: 'Andere',
        religionPers: 'Meine Personalien dürfen dem Seelsorger der Kirchgemeinde mitgeteilt werden.',
        hausArzt: 'Hausarzt / Hausärztin',
        relative1Title: 'Angehörige/r 1',
        relative2Title: 'Angehörige/r 2',
        relation: 'Beziehung',
        relationOther: 'Andere Beziehung',
        basicInsuranceTitle: 'Grundversicherung',
        insuranceOrt: 'Ort (Versicherung)',
        insurancePolicyNo: 'Policen-Nr',
        additionalInsuranceQuestion: 'Zusatz-Versicherung Krankenkasse?',
        additionalInsuranceName: 'Name der Versicherung',
        additionalInsuranceOrt: 'Ort (Versicherung)',
        additionalInsuranceNo: 'Policen-Nr Zusatzversicherung',
        accidentInsurance: 'Unfallversicherung',
        accidentInsuranceOrt: 'Ort (Unfallversicherung)',
        accidentInsuranceNo: 'Schadennummer/Police',
        accidentDate: 'Unfalldatum',
        accidentInfoText:
            'Informieren Sie bitte Ihren Arbeitgeber über den Unfall, da wir ansonsten Ihnen die Rechnung zustellen müssen.',
        employerTitle: 'Arbeitgeber',
        comfortUpgradesTitle: 'Komfort-Upgrades',
        comfortUpgradesInfoLine1: 'Upgrade: Hotelkomfort/Zimmerwunsch (kostenpflichtig, {link})',
        comfortUpgradesInfoLine1Link: 'Preise finden Sie in der Eintrittsbroschüre',
        comfortUpgradesInfoLine2:
            'Die Verfügbarkeit von entsprechenden Zimmern kann nicht garantiert werden. Die ärztliche Betreuung bleibt trotz Upgrade gleich.',
        comfortUpgradesInfoLine3: 'Sie erhalten für das Upgrade eine separate Rechnung zu Ihren Lasten.',
        comfortUpgrade1: 'Allg. Versichert in 1er-Zimmer, allgemeine Abteilung',
        comfortUpgrade2: 'Allg. Versichert 2er-Zimmer, Upgrade 8. Stock, Halbprivatleistungen Hotellerie/Pflege',
        comfortUpgrade3: 'Allg. Versichert 1er Zimmer, Upgrade 8. Stock, Privatleistungen Hotellerie/Pflege',
        comfortUpgrade4: 'Halbprivat Versichert 1er-Zimmer, Upgrade 8. Stock, Privatleistungen Hotellerie/Pflege',
        privacyPolicyText: 'Hiermit bestätige ich, dass ich die {link} gelesen habe.',
        privacyPolicyLink: 'Datenschutzbestimmungen',
    },
    __RELATIVE_SOURCE_FILE__
);
